<template>
  <label>
    <select v-model="selectedOption" aria-label="dropdown filter for date">
      <option :value="null" default>{{ name }}</option>
      <option v-for="option in options" :value="option" :key="option.value">
        {{ option.value.getFullYear() }}
      </option>
    </select>
  </label>
</template>

<script lang="ts">
import Vue from "vue";

import { GenericSearchResponseFacetsCreatedItem } from "../client/src/models/index";

export default Vue.extend({
  name: "DateFilterDropDown",
  props: {
    name: {
      type: String,
      required: true,
      default: "Publish date"
    },
    open: {
      type: Boolean
    },
    options: {
      type: Array as () => GenericSearchResponseFacetsCreatedItem[],
      required: true,
      default: () => []
    },
    active: {
      type: Array as () => GenericSearchResponseFacetsCreatedItem[],
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      selectedOption: null as GenericSearchResponseFacetsCreatedItem
    };
  },
  watch: {
    selectedOption: function() {
      if (this.$data.selectedOption !== null) {
        const emitObject = {
          value: this.$data.selectedOption.value,
          count: this.$data.selectedOption.count
        } as GenericSearchResponseFacetsCreatedItem;
        this.$emit("inputChange", emitObject);
        this.$data.selectedOption = null;
      }
    }
  },
  methods: {
    isChecked(value: Date): boolean {
      return (
        this.$props.active
          .map(function(
            e: GenericSearchResponseFacetsCreatedItem
          ) {
            return e.value;
          })
          .indexOf(value) > -1
      );
    },
    showCheckboxes() {
      this.$emit("toggleFilters");
    }
  }
});
</script>
